import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { RenderInput } from './Base';
import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';

import { saveRecipient } from '../../../../redux/actions/recipient.actions';

const mapStateToProps = (state, ownProps) => ({
    recipient: state.recipient
});

class AddRecipientModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            first_name: '',
            middle_name: '',
            last_name: '',
            gender: 'M',
            dob: new Date(),
            email: '',
            country_of_school: '',
            city_of_school: '',
            mef_enrollment_date: new Date(),
            notes: '',
            is_adult_student: false
        };
        this.state = {
            showModal: false,
            form: this.emptyForm
        };
    }
    componentDidMount() {
        window.addEventListener('open-add-recipient-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-add-recipient-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { recipient: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;
        this.setState({
            showModal: true,
            form: detail ? {...detail} : {...this.emptyForm}
        });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, value }) => {
        const { form } = this.state;
        form[value] = text;
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveRecipient();
        }
    }
    saveRecipient = () => {
        const { form } = this.state;
        const { saveRecipient } = this.props;
        saveRecipient({
            ...form,
            mef_enrollment_date: moment(form['mef_enrollment_date']),
            dob: moment(form['dob'])
        });
    }
    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.recipient;
        return (
            <Dialog icon='person'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                title="Save Recipient">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="First Name"
                                    name="first_name"
                                    value={form.first_name}
                                    autoFocus
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Middle Name"
                                    name="middle_name"
                                    value={form.middle_name}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Last Name"
                                    name="last_name"
                                    value={form.last_name}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <div className="flex-column">
                                    <label className="pt-label">
                                        Gender
                                        <div className="pt-select">
                                            <select value={this.state.form.gender.toUpperCase()}
                                                onChange={event => this.onChangeHandler({ text: event.target.value, value: 'gender' })}>
                                                <option value="F">F</option>
                                                <option value="M">M</option>
                                            </select>
                                        </div>
                                    </label>
                                </div>
                                <RenderInput label="Date of Birth"
                                    name="dob"
                                    value={form.dob}
                                    datePicker
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="E-mail"
                                    name="email"
                                    value={form.email}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Country Of School"
                                    name="country_of_school"
                                    value={form.country_of_school}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="City Of School"
                                    name="city_of_school"
                                    value={form.city_of_school}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Student Notes"
                                    name="notes"
                                    value={form.notes}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="MEF Enrollment Date"
                                    name="mef_enrollment_date"
                                    value={form.mef_enrollment_date}
                                    onChangeHandler={this.onChangeHandler}
                                    datePicker />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Adult Student"
                                    name="is_adult_student"
                                    value={form.is_adult_student}
                                    onChangeHandler={this.onChangeHandler}
                                    type="checkbox" />
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large"
                                text="Save Recipient"
                                onClick={this.saveRecipient}
                                isLoading={saveLoading}
                            />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveRecipient }
)(AddRecipientModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/RecipientModal.jsx